/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { Button, Input, Icon, Select, Modal, SelectActions } from '../../components';
import { Globals, Constants, axios } from '../../utils';
import NumberFormat from 'react-number-format';
import TrashIcon from '../../assets/icons/trash.png';

// Función parse ajustada para aceptar decimales
function parse(value, decimals = 2) {
	const multiplier = Math.pow(10, decimals);
	// Se agrega un epsilon minúsculo para contrarrestar errores acumulativos de punto flotante en JS (ej. 156.13249999999996)
	return parseFloat((Math.round((parseFloat(value || 0) + 0.00000001) * multiplier) / multiplier).toFixed(decimals));
}

class EditOrder extends React.Component {

	state = {
		form: {
			client_id: '',
			method_id: '',
			file: '',
			initial_payment: '',
			status: Constants.PAYMENT_TYPES.PAID,
			discount: '',
			credit_days: '',
			information: '',
			show_taxes: Constants.ORDERS.SHOW_TAXES.NO,
			iva: null,
			iva_bs: null,
			currentFileName: '',
			general_discounts: [],
		},
		total: 0,
		methods: [],
		client: null,
		visible: false,
		order: null,
		visible_product: false,
		visible_dates: false,
		dates: [],
		height: 0,
		methods_selected: [],
		disabled_button: false,
		visible_modal: false,
		seller: null,
		sellers: [],
		clients: [],
		warehouses: [],
		formatWarehouses: [],
		config: null,
		general_discounts: [],
		countryEquivalent: Globals.getUserCountryEquivalent(),
		IVA: Globals.getAdminIva(),
		discountsRules: [],
		appliedDiscountsRules: [],
		totals: {
			subtotal_usd: 0,
			subtotal_bs: 0,
			paid_usd: 0,
			paid_bs: 0,
			left_usd: 0,
			left_bs: 0,
			total_bs: 0,
			total_usd: 0,
			change_bs: 0,
			change_usd: 0,
			total_discount: 0,
			total_discount_percentage: 0,
			original_subtotal_usd: 0
		},
	}

	async componentDidMount() {
		Globals.setLoading();
		const order = this.props.order;
		console.log('EditOrder -> componentDidMount -> order: ', order)

		let currentFileName = '';

		if (order?.file) {
			const splitted = String(order.file).split('.');
			currentFileName = `Comprobante.${splitted[splitted.length - 1]}`;
		}

		// Mapear los descuentos generales de la orden al formato { discount_id, value }
		// que usa setTotals para re-evaluar las reglas automáticas.
		// Solo cargamos los de tipo 'general' (controlados por usuario) como valor inicial;
		// los de tipo 'pronto_pago' serán re-evaluados automáticamente por setTotals.
		const discounts = (order?.discounts || [])
			.filter(d => d?.general_discount?.type === 'general')
			.map(d => ({
				discount_id: d.general_discount_id,
				value: parseFloat(d.porcentage) || 0,
			}));

		console.log('order.discounts: ', order.discounts)

		await this.setState({
			form: {
				...this.state.form,
				client_id: order.client_id || '',
				method_id: order.method_id || '',
				status: order.status_payment,
				initial_payment: order.initial_payment || '',
				discount: (() => {
					const principalDiscount = order?.discounts?.find(d => d.general_discount_id === null);
					if (principalDiscount) return parseFloat(principalDiscount.porcentage) || '';
					return order.discount_percentage || '';
				})(),
				credit_days: order.credit_days?.toString() || '',
				information: order.information || '',
				iva: order.iva,
				iva_bs: order.iva_bs,
				show_taxes: order.iva ? Constants.ORDERS.SHOW_TAXES.YES : Constants.ORDERS.SHOW_TAXES.NO,
				currentFileName,
				general_discounts: discounts,
			},
			seller: order.seller,
			order: {
				...order,
				details: order.details.filter(i => i.product && !i.product.deleted_at).reduce((acc, curr) => {
					const existingIndex = acc.findIndex(item =>
						item.product_id === curr.product_id &&
						item.size_id === curr.size_id &&
						item.color_id === curr.color_id
					);

					if (existingIndex !== -1) {
						const existing = acc[existingIndex];
						existing.quantity = (parseFloat(existing.quantity) + parseFloat(curr.quantity)).toString();
						existing.original_quantity = existing.quantity;
						existing.initial_qty = existing.quantity;
						existing._merged_from_limit = true;

						const currPrice = parseFloat(curr.price);
						const existingPrice = parseFloat(existing.price);
						if (currPrice > existingPrice) {
							existing.price = curr.price;
							existing.selected_price = curr.price;
							existing._user_selected_price = curr.price;
							existing.initial_price = curr.price;
							existing.original_price = curr.price;
						}
					} else {
						const newItem = { ...curr };
						newItem.discount = newItem.discount_percentage;
						newItem.selected_price = newItem.price;
						newItem._user_selected_price = newItem.price;
						newItem.original_quantity = newItem.quantity;
						newItem.warehouse_id = newItem.warehouse_id;
						// Determinar si el descuento guardado es manual o de regla automática.
						// detail.discounts[]: discount_id===null → manual; discount_id!=null → regla automática.
						const detailDiscounts = curr.discounts || [];
						const manualDetailDiscount = detailDiscounts.find(d => d.discount_id === null);
						const autoDetailDiscounts = detailDiscounts.filter(d => d.discount_id !== null);

						if (manualDetailDiscount) {
							// Hay descuento manual guardado en la BD
							newItem.manual_discount = parseFloat(manualDetailDiscount.porcentage) || 0;
						} else if (autoDetailDiscounts.length > 0) {
							// Fue automático (regla); se recalculará o se preservará
							newItem.manual_discount = 0;
						} else {
							// Sin información de detalle: tratar discount_percentage como manual
							const rawDisc = String(newItem.discount_percentage || '0').replace(/%/g, '').trim();
							newItem.manual_discount = parseFloat(rawDisc) || 0;
						}

						if (autoDetailDiscounts.length > 0) {
							newItem.saved_applied_rules = autoDetailDiscounts.map(d => ({
								discount_id: d.discount_id,
								name: d.discount ? d.discount.name : 'Descuento Automático',
								percentage: parseFloat(d.porcentage)
							}));
							newItem.saved_item_percentage = newItem.saved_applied_rules.reduce((sum, r) => sum + r.percentage, 0);
						}

						newItem.initial_qty = newItem.quantity;
						newItem.initial_price = newItem.price;
						acc.push(newItem);
					}
					return acc;
				}, [])
			},
			client: order.client,
			dates: order.paydays?.map(i => moment(i.date).format('DD-MM-YYYY')),
			methods_selected: (order.payment_methods || []).map(i => {
				const methodObj = (this.props.methods || []).find(m => m.value == i.method_id);
				return {
					id: i.method_id,
					name: methodObj?.label || '',
					amount: i.amount.toString(),
					created_at: i.created_at
				}
			})
		});

		await this.load();
		await this.getConfig();
		await this.getNewDiscounts();
		await this.getSellers();
		await this.setTotals();

		Globals.quitLoading();
	}

	getSellers = async () => {
		try {
			const filter = {
				user_id: this.props.user.id,
			};
			const res = await axios.post('web/admin/orders/sellers', filter);
			if (res.data?.sellers) {
				const sellers = res.data.sellers.data || res.data.sellers;

				// Reemplazar this.state.seller con el objeto completo (que incluye zone_id)
				// para que setTotals() evalúe correctamente ruta_vendedor desde el inicio.
				const currentSellerId = this.state.seller?.id || this.state.order?.seller_id;
				const fullSeller = currentSellerId
					? sellers.find(s => +s.id === +currentSellerId)
					: null;

				await this.setState({
					fullSellers: sellers,
					...(fullSeller ? { seller: fullSeller } : {}),
				});
			}
		} catch (error) { }
	}

	// Helper para obtener la cantidad de decimales según config
	getDecimals = () => {
		const config = this.state.config || this.props.user?.config;
		return config?.three_decimals === Constants.STATUS_ACTIVE ? 3 : 2;
	}

	enableSubmit = () => {
		return this.setState({
			disabled_button: false
		});
	}

	load = async () => {
		this.getWarehouses();
	}

	getAdminGeneralDiscounts = async () => {
		await axios
			.post("admin/profile/generaldiscounts/get", { user_id: this.props.user.id, last_three: true })
			.then(({ data }) => {
				const newDiscounts = data.discounts
					.filter(d => !this.state.form.general_discounts.some(i => i.general_discount_id === d.id))
					.map(d => ({
						name: d?.name,
						general_discount_id: d.id,
						porcentage: ''
					}));

				this.setState({
					general_discounts: data.discounts,
					form: {
						...this.state.form,
						general_discounts: this.state.form.general_discounts.concat(newDiscounts),
					}
				});
			})
			.catch(() => Globals.showError())
			.then(() => Globals.quitLoading());
	}


	getNewDiscounts = async () => {
		try {
			const res = await axios.post('admin/discounts/get', { user_id: this.props.user.id, all: true, status: Constants.STATUS_ACTIVE });
			if (res.data?.discounts) {
				const validDiscounts = res.data.discounts.filter(d => d.status === 1);
				this.setState({ discountsRules: validDiscounts });
			}
		} catch (error) {
			console.log('Error fetching discounts:', error);
		}
	}

	getConfig = async () => {
		try {
			const { data } = await axios.post("sync/config", { user_id: this.props.user.id });
			this.setState({ config: data.config });
		} catch (error) {
			Globals.showError();
		}
	};

	getWarehouses = async () => {
		try {
			const data = {
				web: true,
				user_id: this.props.user.id,
				is_select: true,
				//Comentado para prod
				warehouse_id: this.props.user.level_id == Constants.ROLE_ADMIN ? null : this.props.user.warehouse_id,
				// warehouse_id: this.props.user.warehouse_principal,
				without_products: true,
				unique_by_size_color: true, // evita N rows por producto (1 por talla/color) → respuesta más liviana
			};

			const res = await axios.post('web/admin/warehouses', data);
			if (res.data?.warehouses) {
				const formatWarehouses = res.data.warehouses.map(Item => ({
					value: Item.id,
					label: Item.name
				}));

				const mainIdx = formatWarehouses.findIndex(x => x.value === this.props.user.warehouse_principal);
				if (mainIdx >= 0) {
					const main = formatWarehouses[mainIdx];
					formatWarehouses.splice(mainIdx, 1);
					formatWarehouses.unshift(main);
				}

				this.setState({
					warehouses: res.data.warehouses,
					formatWarehouses: formatWarehouses
				});
			}
		} catch (error) {
			Globals.showError();
			console.log('NewRequest -> getWarehouses -> catch: ', error);
		}
	}

	change = (value, target) => {
		this.setState(
			{
				form: {
					...this.state.form,
					[target]: value
				}
			},
			// Recalcular totales cuando cambien campos que afectan descuentos
			['credit_days', 'discount'].includes(target) ? () => this.setTotals() : undefined
		);
	}

	changeGeneralDiscount = async (discountId, value) => {
		await this.setState(state => {
			const general_discounts = [...state.form.general_discounts];
			const index = general_discounts.findIndex(d => d.discount_id === discountId);

			if (index >= 0) {
				// Actualizar existente
				general_discounts[index] = { ...general_discounts[index], value };
			} else {
				// Agregar nuevo
				general_discounts.push({ discount_id: discountId, value });
			}

			return {
				form: {
					...state.form,
					general_discounts,
				}
			};
		});

		this.setTotals();
	}

	checkedChange = async (newValue) => {
		await this.setState(prevState => ({
			form: {
				...prevState.form,
				show_taxes: newValue == true ? Constants.ORDERS.SHOW_TAXES.YES : Constants.ORDERS.SHOW_TAXES.NO,
				iva: newValue == false ? null : prevState.form.iva,
				iva_bs: newValue == false ? null : prevState.form.iva_bs,
			}
		}));
		this.setTotals()
	}

	delete = (index) => {
		Globals.confirm('¿Desea eliminar el producto del pedido?', () => {
			let order = { ...this.state.order };
			order.details.splice(index, 1);
			this.setState({ order, orderModified: true }, () => this.setTotals());
		});
	}

	add = (index, item) => {
		if (item) {
			const product = item?.product;
			let stock = product?.stock || 0;

			let size_color = null;

			if (product?.type == Constants.PRODUCTS_TYPE.SIZE_COLOR) {
				size_color = product?.size_colors?.find((i) => {
					if (item.size_id && item.color_id) {
						return i.size_id == item.size_id && i.color_id == item.color_id;
					}
					else if (item.size_id) {
						return i.size_id == item.size_id && i.color_id == null;
					}
					else if (item.color_id) {
						return i.color_id == item.color_id && i.size_id == null;
					}
				});
				stock = size_color?.stock || 0;
			}

			let order = { ...this.state.order };
			let qty = Number(order.details[index].quantity)

			// Ajuste para incrementar con decimales si corresponde
			qty = parseFloat(qty + 1).toFixed(2)

			// Si en config, el negative_stock es NO, evaluamos el stock
			if (this.state.config?.negative_stock == Constants.CONFIG.NO) {
				if (Number(qty) > stock) {
					if (qty <= item.original_quantity) {
						order.details[index].quantity = qty;
						order.details[index]._edited = true;
						this.setState({ order, orderModified: true }, () => this.setTotals());
						return;
					}
					return;
				}
			}

			order.details[index].quantity = qty;
			order.details[index]._edited = true;
			this.setState({ order, orderModified: true }, () => this.setTotals());
		}
		else {
			let order = { ...this.state.order };
			order.details[index].quantity++;
			order.details[index]._edited = true;
			this.setState({ order, orderModified: true }, () => this.setTotals());
		}
	}

	remove = (index) => {
		let order = { ...this.state.order };
		if (order.details[index].quantity > 1) {
			let qty = order.details[index].quantity
			qty = parseFloat(qty - 1).toFixed(2)
			order.details[index].quantity = qty;
			order.details[index]._edited = true;
			this.setState({ order, orderModified: true }, () => this.setTotals());
		}
	}

	changeManual = (index, quantity) => {
		let order = { ...this.state.order };
		order.details[index].quantity = quantity;
		order.details[index]._edited = true;
		this.setState({ order }, () => this.setTotals());
	}

	submit = async () => {
		if (this.state.order.details.filter(i => {
			return i.type == Constants.PRODUCTS_TYPE.SIZE_COLOR && !i.size_id && !i.color_id;
		}).length > 0) {
			Globals.showError("Por favor, ingrese el color/talla de los productos que lo requieran");
			this.enableSubmit();
			return false;
		}

		for (let index = 0; index < this.state.order.details.length; index++) {
			const i = this.state.order.details[index];
			const product = this.state.order.details.find(_i => _i.product_id == i.product_id);
			if (product.type == Constants.PRODUCTS_TYPE.SIZE_COLOR) {
				const item_find = this.state.order.details.find((item, _index) => {
					if (index != _index) {
						if (item.product_id == i.product_id && item.color_id == i.color_id && item.size_id == i.size_id) {
							return true;
						}
					}

					return false;
				});

				if (item_find) {
					const color = item_find.size_colors.find(_i => _i.color_id == i.color_id)?.color;
					const size = item_find.size_colors.find(_i => _i.size_id == i.size_id)?.size;
					const product = this.state.order.details.find(_i => _i.product_id == i.product_id);
					Globals.showError(`Lo sentimos, el producto ${product?.name} (${[size?.name, color?.name].filter(i => i != null).join(',')}) se encuentra más de una vez en la orden`);
					this.enableSubmit();
					return false;
				}
			}
		}

		for (let i = 0; i < this.state.order.details.length; i++) {
			const item = this.state.order.details[i];
			const product = this.state.order.details.find(_i => _i.product_id == item.product_id);
			if (product.type == Constants.PRODUCTS_TYPE.SIZE_COLOR) {
				const size_color = product?.size_colors?.find((i) => {
					if (item.size_id && item.color_id) {
						return i.size_id == item.size_id && i.color_id == item.color_id;
					}
					else if (item.size_id) {
						return i.size_id == item.size_id && i.color_id == null;
					}
					else if (item.color_id) {
						return i.color_id == item.color_id && i.size_id == null;
					}
				});
				if (!size_color) {
					const color = product.size_colors.find(_i => _i.color_id == item.color_id)?.color;
					const size = product.size_colors.find(_i => _i.size_id == item.size_id)?.size;
					Globals.showError(`Lo sentimos, el producto ${product?.name} (${[size?.name, color?.name].filter(i => i != null).join(',')}) no se encuentra en inventario`);
					this.enableSubmit();
					return false;
				}
			}
		}

		if (this.state.form.status == Constants.PAYMENT_TYPES.TO_PAY && this.state.form.credit_days <= 0) {
			Globals.showError("Debe ingresar los días de crédito");
			this.enableSubmit();
			return false;
		}

		if (this.state.order.details.filter(i => !i.quantity || i.quantity == 0).length > 0) {
			Globals.showError("Debe seleccionar la cantidad de todos los productos");
			this.enableSubmit();
			return false;
		}

		if (this.state.order.details.filter(i => !i.selected_price).length > 0) {
			Globals.showError("Debe seleccionar el precio de todos los productos");
			this.enableSubmit();
			return false;
		}

		if (this.state.form.status == Constants.PAYMENT_TYPES.TO_PAY) {
			const total = this.getTotal()
			const sumOfMethods = this.state.methods_selected.map(i => i.amount).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);

			if (sumOfMethods > this.state.form.initial_payment) {
				Globals.showError("El pago inicial debe ser igual a la suma de los métodos de pago.");
				this.enableSubmit();
				return false;
			}

			if (this.state.form.initial_payment >= total) {
				Globals.showError("El pago inicial no puede ser igual o mayor al monto total. Este es un pedido por cobrar");
				this.enableSubmit();
				return false;
			}

			if (sumOfMethods >= total) {
				Globals.showError("La suma de los métodos de pago no puede ser igual o mayor al monto total. Este es un pedido por cobrar");
				this.enableSubmit();
				return false;
			}
		}

		if (this.state.form.discount != '' && this.state.form.discount > 100) {
			Globals.showError("El porcentaje de descuento general no puede ser mayor a 100%");
			this.enableSubmit();
			return false;
		}

		const detail = this.state.order.details.find((i) => {
			const product = this.state.order.details.find((_i) => _i.product_id == i.product_id);
			if (product.type == Constants.PRODUCTS_TYPE.SIZE_COLOR) {
				const size_color = product?.size_colors?.find((_i) => {
					if (i.size_id && i.color_id) {
						return _i.size_id == i.size_id && _i.color_id == i.color_id;
					}
					else if (i.size_id) {
						return _i.size_id == i.size_id && _i.color_id == null;
					}
					else if (i.color_id) {
						return _i.color_id == i.color_id && _i.size_id == null;
					}
				});

				return (parseInt(product.stock) + parseInt(i.original_quantity)) < i.quantity;
			}
			else {
				return (parseInt(product.stock) + parseInt(i.original_quantity)) < i.quantity;
			}
		});

		if (detail) {
			const product = this.state.order.details.find((i) => i.product_id == detail.product_id);
			const size_color = product?.size_colors?.find((_i) => {
				if (detail.size_id && detail.color_id) {
					return _i.size_id == detail.size_id && _i.color_id == detail.color_id;
				}
				else if (detail.size_id) {
					return _i.size_id == detail.size_id && _i.color_id == null;
				}
				else if (detail.color_id) {
					return _i.color_id == detail.color_id && _i.size_id == null;
				}
			});
			if (product) {
				if (product.type == Constants.PRODUCTS_TYPE.SIZE_COLOR) {
					const color = product.size_colors.find(_i => _i.id == detail.color_id)?.color;
					const size = product.size_colors.find(_i => _i.id == detail.size_id)?.size;
					Globals.showError("Lo sentimos, el producto " + product.name + ` (${[size?.name, color?.name].filter(i => i != null).join(',')}) no tiene suficiente stock (` + (parseInt(size_color?.stock) + parseInt(detail.original_quantity)) + ")");
				}
				else {
					Globals.showError("Lo sentimos, el producto " + product.name + " no tiene suficiente stock (" + (parseInt(product.stock) + parseInt(detail.original_quantity)) + ")");
				}
				this.enableSubmit();
				return false;
			}
		}

		// --- CORRECCIÓN AQUÍ: Validación de montos con decimales dinámicos ---
		if (this.state.form.status != Constants.PAYMENT_TYPES.TO_PAY || this.state.form.initial_payment != '') {
			if (this.state.methods_selected.length == 0) {
				Globals.showError("Debe seleccionar al menos 1 método de pago");
				this.enableSubmit();
				return false;
			}

			if (this.state.methods_selected.filter(i => !i.amount).length > 0) {
				Globals.showError("Debe ingresar el monto de cada método de pago");
				this.enableSubmit();
				return false;
			}

			let total = this.getTotal();
			let message = "La suma de los métodos de pago deben ser igual al total";

			if (this.state.form.status == Constants.PAYMENT_TYPES.TO_PAY) {
				total = this.state.form.initial_payment;
				message = "La suma de los métodos de pago deben ser igual al pago inicial";
			}

			const decimals = this.getDecimals(); // Obtenemos 2 o 3 según configuración
			const tolerance = 0.0001;

			// Sumamos los métodos de pago
			const sumOfMethods = this.state.methods_selected.map(i => i.amount).reduce((a, b) => parseFloat(a) + parseFloat(b), 0);

			// Redondeamos AMBOS valores a la cantidad de decimales configurada (ej. 3) antes de comparar
			// Esto evita que Globals.roundMiles fuerce 2 decimales y cause el error
			const roundedSum = parse(sumOfMethods, decimals);
			const roundedTotal = parse(total, decimals);

			if (Math.abs(roundedSum - roundedTotal) > tolerance) {
				console.log('Error validación montos:');
				console.log('Sum:', roundedSum, 'Total:', roundedTotal, 'Diff:', Math.abs(roundedSum - roundedTotal));

				Globals.showError(message);
				this.enableSubmit();
				return false;
			}
		}
		// --------------------------------------------------------------------

		if (this.state.form.show_taxes == Constants.ORDERS.SHOW_TAXES.YES) {
			//Obtengo el iva y iva_bs
			const iva = this.getIva()
			const iva_bs = this.getIvaBs()
			this.setState({
				form: {
					...this.state.form,
					iva: iva,
					iva_bs: iva_bs,
				}
			});
		}



		Globals.setLoading();

		const expandedDetails = [];
		for (const item of this.state.order.details) {
			if (
				item.special_price_applied &&
				item.special_price_limit != null &&
				item.special_price_limit > 0
			) {
				const decimals = this.getDecimals();
				const qty = item.decimal_stock == Constants.DECIMAL_STOCK.YES
					? parseFloat(item.quantity)
					: parseInt(item.quantity);
				const specialQty = parseFloat(item.special_price_limit);
				const regularQty = qty - specialQty;

				const originalPrice = parseFloat(item.original_price || item.sale_price || item.price);
				const specialPrice = parseFloat(item.original_special_price || item.special_price_limit_price || 0) || null;

				// Fila 1: unidades al precio especial
				expandedDetails.push({
					...item,
					quantity: specialQty,
					selected_price: specialPrice || item.selected_price,
					sale_price: specialPrice || item.sale_price,
					subtotal: parseFloat((specialQty * (specialPrice || item.selected_price)).toFixed(decimals)),
					special_price_applied: true,
					special_price_limit: null, // ya expandido, no repetir
				});

				// Fila 2: unidades al precio normal (solo si queda cantidad restante)
				if (regularQty > 0) {
					expandedDetails.push({
						...item,
						quantity: regularQty,
						selected_price: originalPrice,
						sale_price: originalPrice,
						subtotal: parseFloat((regularQty * originalPrice).toFixed(decimals)),
						special_price_applied: false,
						special_price_limit: null, // ya expandido
					});
				}
			} else {
				expandedDetails.push(item);
			}
		}


		const data = {
			...this.state.form,
			seller_id: this.state.seller?.id || this.state.seller?.value || this.state.order?.seller_id || this.props.user.id,
			hasFile: true,
			details: JSON.stringify(expandedDetails),
			currency: this.props.currency,
			order_id: this.state.order.id,
			user_id: this.props.user?.id,
			methods_selected: JSON.stringify(this.state.methods_selected),
			general_discounts: JSON.stringify(this.state.form.general_discounts),
			onError: () => {
				this.enableSubmit();
			}
		}
		console.log('data: ', data)
		try {
			const res = await axios.upload('admin/orders/edit', data);

			//Mensaje de error
			if (res.data?.result == false) {
				Globals.showError(res.data?.error ?? 'El cliente ya ha alcanzado su limite de crédito permitido');
				Globals.quitLoading();
				return
			}

			Globals.showSuccess("Se ha modificado su pedido correctamente");
			this.props.onClose(true);

			// TODO: Habilitar el socket en el front para notificar el cambio
			// res.notifications?.forEach(item => {
			// 	Socket.emit(SocketEvents.STOCK.ALERT,{
			// 		message: item,
			// 		seller_id: this.state.order.seller_id
			// 	});
			// });

			// res.notifications_zero?.forEach(item => {
			// 	Socket.emit(SocketEvents.STOCK.ZERO,{
			// 		message: item,
			// 		seller_id: this.state.order.seller_id
			// 	});
			// });

		} catch (error) {
			this.enableSubmit();
			console.log(error);
			Globals.showError(error?.response?.data?.error || 'Ocurrió un error al editar el pedido');
		}

		Globals.quitLoading();
	}

	selectClient = () => {
		this.setState({
			visible: true
		});
	}

	onClose = (client = null) => {
		this.setState({
			visible: false
		});
		if (client) {
			this.setState({ client, form: { ...this.state.form, client_id: client.value } }, () => this.setTotals());
		}
	}

	setTotals = async () => {
		const { form, order, discountsRules } = this.state;
		const exchangeRate = order?.conversion || 1;
		const decimals = this.getDecimals();

		let subtotal_usd = 0;
		let original_subtotal_usd = 0;
		let totalDiscountAmount = 0;

		const products = [...order.details];
		const paid_usd = (this.state.methods_selected || []).reduce((acc, curr) => acc + Number(curr.amount), 0);
		const paid_bs = parse(paid_usd * exchangeRate, decimals);

		const isOdooUser = this.props.user && ((this.props.user.admin ? this.props.user.admin.odoo : this.props.user.odoo) == 1);
		const checkIsBultoCajaCestaUnidad = (prod) => Globals.checkIsBultoCajaCestaUnidad(prod, isOdooUser);
		// Volumen: solo bultos/cajas/cestas (excluye "Unidad")
		const checkIsBultoCajaCesta = (prod) => Globals.checkIsBultoCajaCesta(prod, isOdooUser);

		// ---------------------------------------------------------
		// 1. RECOPILAR DESCUENTOS GLOBALES (General y Pronto Pago)
		// ---------------------------------------------------------
		let new_general_discounts = [];

		if (discountsRules && discountsRules.length > 0) {
			discountsRules.forEach(master => {
				if (master.status !== 1) return;

				// A. Descuento General (Ahora es controlado por el usuario)
				if (master.type === 'general') {
					// Buscamos si el usuario especificó un porcentaje en el estado
					const userDiscount = form.general_discounts.find(d => d.discount_id === master.id);
					if (userDiscount && userDiscount.value !== '') {
						new_general_discounts.push({
							discount_id: master.id,
							value: userDiscount.value
						});
					}
				}

				// B. Pronto Pago
				if (master.type === 'pronto_pago' && form.status == Constants.PAYMENT_TYPES.TO_PAY && (this.state.client || form.client_id) && form.credit_days) {
					const days = parseInt(form.credit_days);
					const clientId = this.state.client.id || this.state.client.value || form.client_id;
					if (!isNaN(days) && days > 0 && clientId) {
						master.discount_details.forEach(rule => {
							// Usar == (comparación flexible) para evitar problemas de tipo string vs number
							if (rule.client_id == clientId && days <= rule.max_days) {
								new_general_discounts.push({ discount_id: master.id, value: parseFloat(rule.percentage) });
							}
						});
					}
				}
			});
		}

		const cartProductIds = products.map(item => item.product_id || item.id);
		const hasAnyOrderEdit = !!this.state.orderModified || products.some(p => p._edited);

		// ---------------------------------------------------------
		// 2. CÁLCULO LÍNEA POR LÍNEA
		// ---------------------------------------------------------
		for (const product of products) {
			const qty = (product?.decimal_stock ?? product.product?.decimal_stock) == Constants.DECIMAL_STOCK.YES ? parseFloat(product.quantity) : parseInt(product.quantity);

			let originalPrice = parseFloat(product.original_price || product.sale_price || product.price);
			if (product._user_selected_price !== undefined) {
				originalPrice = parseFloat(product._user_selected_price);
			}

			let appliedPrice = originalPrice;
			let itemPercentageDiscount = 0;
			let applied_rules = []; // Seguimiento de descuentos por producto

			// En edit-order, 'product' es el detalle de la orden y la data del producto está en 'product.product'
			const productData = product.product || product;
			let defaultPriceToCompare = productData.default_price_value;

			if (productData.type === Constants.PRODUCTS_TYPE.SIZE_COLOR && productData.size_colors) {
				const size_color = productData.size_colors.find(i =>
					(product.size_id && product.color_id && i.size_id === product.size_id && i.color_id === product.color_id) ||
					(product.size_id && !product.color_id && i.size_id === product.size_id && !i.color_id) ||
					(product.color_id && !product.size_id && i.color_id === product.color_id && !i.size_id)
				);
				if (size_color && size_color.sale_price != null) {
					defaultPriceToCompare = size_color.sale_price;
				}
			}
			product.special_price_applied = false;
			product.special_price_limit = null;

			const limitMaster = (discountsRules || []).find(m =>
				m.status === 1 &&
				m.type === 'limite_cantidad' &&
				m.discount_details?.some(r => r.product_id === (product.product_id || product.id))
			);
			const limitRule = limitMaster?.discount_details?.find(r => r.product_id === (product.product_id || product.id));

			if (limitRule && defaultPriceToCompare != null && !product._user_changed_price && parseFloat(originalPrice) === parseFloat(limitRule.special_price)) {
				originalPrice = parseFloat(defaultPriceToCompare);
				appliedPrice = originalPrice;
			}

			const isDefaultPrice = defaultPriceToCompare == null || parseFloat(originalPrice) === parseFloat(defaultPriceToCompare);
			const isUnmodified = product.initial_qty !== undefined &&
				parseFloat(qty) === parseFloat(product.initial_qty) &&
				(parseFloat(originalPrice) === parseFloat(product.initial_price) || (limitRule && parseFloat(product.initial_price) === parseFloat(limitRule.special_price)));

			if (isDefaultPrice && limitRule) {
				if (qty <= limitRule.max_quantity) {
					appliedPrice = parseFloat(limitRule.special_price);
					product.special_price_applied = true;
					product.special_price = appliedPrice;
					product.original_special_price = appliedPrice;
					product.original_price = originalPrice;
					product.special_price_limit = null;
				} else if (limitRule.max_quantity && qty > limitRule.max_quantity) {
					const specialQty = parseFloat(limitRule.max_quantity);
					const regularQty = qty - specialQty;
					appliedPrice = ((specialQty * parseFloat(limitRule.special_price)) + (regularQty * originalPrice)) / qty;
					product.special_price_applied = true;
					product.special_price = parse(appliedPrice, decimals);
					product.original_special_price = parseFloat(limitRule.special_price);
					product.original_price = originalPrice;
					product.special_price_limit = specialQty;
				}
			}

			// EVALUAR REGLAS POR PRODUCTO
			if (!hasAnyOrderEdit && isUnmodified && product.saved_applied_rules) {
				applied_rules = [...product.saved_applied_rules];
				itemPercentageDiscount = product.saved_item_percentage;
			} else if (discountsRules && discountsRules.length > 0 && isDefaultPrice) {
				discountsRules.forEach(master => {
					if (master.status !== 1) return;

					let rutaVendedorApplied = false;
					let applicableVolumenRules = [];

					master.discount_details.forEach(rule => {

						// Por Volumen
						if (master.type === 'volumen') {
							if ((rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === (product.category_id || productData?.category_id))) && qty >= rule.min_quantity) {
								applicableVolumenRules.push(rule);
							}
						}

						// Por Ruta / Vendedor
						if (master.type === 'ruta_vendedor' && rule.product_id === (product.product_id || product.id) && !rutaVendedorApplied) {
							// Si no se seleccionó vendedor explícitamente, usar el usuario logueado como fallback
							const activeSeller = this.state.seller || this.props.user;
							const sellerId = activeSeller ? activeSeller.id || activeSeller.value : null;
							let isInZone = false;
							if (rule.zone_id && activeSeller) {
								if (activeSeller.zones && activeSeller.zones.length > 0) {
									isInZone = activeSeller.zones.some(z => z.id == rule.zone_id || z.zone_id == rule.zone_id);
								} else if (activeSeller.zone_id == rule.zone_id) {
									isInZone = true;
								}
							}

							// Aplica por zona DEL VENDEDOR seleccionado, o estrictamente por el ID del vendedor
							if (isInZone || (rule.seller_id && rule.seller_id == sellerId)) {
								itemPercentageDiscount += parseFloat(rule.percentage);
								applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
								rutaVendedorApplied = true;
							}
						}

						// Por Surtido
						if (master.type === 'surtido' && rule.product_id === (product.product_id || product.id)) {
							let distinctCount = 0;
							master.discount_details.forEach(surtidoRule => {
								if (surtidoRule.counts_for_calculation && cartProductIds.includes(surtidoRule.product_id)) distinctCount++;
							});

							if (distinctCount >= rule.min_quantity) {
								itemPercentageDiscount += parseFloat(rule.percentage);
								applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
							}
						}
						// Por Surtido y Volumen
						if (master.type === 'surtido_volumen' && (rule.product_id === (product.product_id || product.id) || (rule.category_id && rule.category_id === (product.category_id || productData?.category_id)))) {
							const isProductBulto = checkIsBultoCajaCestaUnidad(product);
							if (isProductBulto) {
								let participatingCartProdIds = [];
								let totalBultos = 0;

								products.forEach(cartProd => {
									const isCartProdBulto = checkIsBultoCajaCestaUnidad(cartProd);
									const isParticipating = master.discount_details.some(svRule =>
										(svRule.product_id === (cartProd.product_id || cartProd.id) || (svRule.category_id && svRule.category_id === (cartProd.category_id || cartProd.product?.category_id)))
										&& svRule.counts_for_calculation
									);
									if (isParticipating && isCartProdBulto) {
										// Surtido (SKU distintos): incluye "Unidad"
										const actualCartProdId = cartProd.product_id || cartProd.id;
										if (!participatingCartProdIds.includes(actualCartProdId)) {
											participatingCartProdIds.push(actualCartProdId);
										}
									}
									if (isParticipating && checkIsBultoCajaCesta(cartProd)) {
										// Volumen (total bultos/cajas/cestas): NO incluye "Unidad"
										const cDecStock = cartProd.decimal_stock ?? cartProd.product?.decimal_stock;
										const qtyProd = cDecStock == 1 || cDecStock == '1' || cDecStock == true ? parseFloat(cartProd.quantity) : parseInt(cartProd.quantity);
										totalBultos += qtyProd;
									}
								});

								let distinctCount = participatingCartProdIds.length;
								const meetsSku = distinctCount >= rule.min_sku;
								const meetsBultos = totalBultos >= rule.min_bultos;

								if (meetsSku && meetsBultos) {
									const pctOne = parseFloat(rule.percentage_one_condition);
									const pctBoth = parseFloat(rule.percentage_both_conditions);
									if (meetsSku !== meetsBultos)
									if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
										itemPercentageDiscount += pctOne;
										applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
									}
									if (!isNaN(pctBoth) && pctBoth > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
										itemPercentageDiscount += pctBoth;
										applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctBoth });
									}
								} else if (meetsSku || meetsBultos) {
									const pctOne = parseFloat(rule.percentage_one_condition);
									if (!isNaN(pctOne) && pctOne > 0 && !applied_rules.some(r => r.discount_id === master.id)) {
										itemPercentageDiscount += pctOne;
										applied_rules.push({ discount_id: master.id, name: master.name, percentage: pctOne });
									}
								}
							}
						}

					});

					if (master.type === 'volumen' && applicableVolumenRules.length > 0) {
						const categoryRules = applicableVolumenRules.filter(r => r.category_id && r.category_id === (product.category_id || productData?.category_id));
						const rulesToApply = categoryRules.length > 0 ? categoryRules : applicableVolumenRules;

						rulesToApply.forEach(rule => {
							itemPercentageDiscount += parseFloat(rule.percentage);
							applied_rules.push({ discount_id: master.id, name: master.name, percentage: parseFloat(rule.percentage) });
						});
					}
				});
			}

			if (itemPercentageDiscount > 100) itemPercentageDiscount = 100;

			// manual_discount es inicializado en componentDidMount usando detail.discounts[] de la BD.
			// changeValue() lo actualiza cuando el usuario edita el campo de descuento en la UI.
			// Este bloque solo aplica como fallback para productos nuevos agregados en el modal
			// (que no tienen el historial de detail.discounts[]).
			if (product.manual_discount === undefined) {
				const rawStr = String(product.discount_percentage || product.discount || '0').trim();
				const discountStr = rawStr.replace(/%/g, '').trim();
				if (discountStr.includes('/')) {
					product.manual_discount = parseFloat(discountStr.split('/')[0]) || 0;
				} else if (discountStr.includes('+')) {
					product.manual_discount = parseFloat(discountStr.split('+')[0]) || 0;
				} else {
					product.manual_discount = parseFloat(discountStr) || 0;
				}
			}

			// Aplicar descuentos en cascada sobre el precio aplicado
			let finalUnitPrice = appliedPrice;

			// 1. Aplicar descuento manual si existe
			if (product.manual_discount > 0) {
				let manualDesc = parseFloat(product.manual_discount);
				if (manualDesc > 100) manualDesc = 100;
				finalUnitPrice -= (finalUnitPrice * (manualDesc / 100));
			}

			// 2. Aplicar descuento automático de reglas en cascada (volumen, ruta, surtido_volumen, etc.)
			if (applied_rules.length > 0) {
				applied_rules.forEach(ar => {
					let ruleDesc = parseFloat(ar.percentage);
					if (!isNaN(ruleDesc) && ruleDesc > 0) {
						if (ruleDesc > 100) ruleDesc = 100;
						finalUnitPrice -= (finalUnitPrice * (ruleDesc / 100));
					}
				});
			}

			if (finalUnitPrice < 0) finalUnitPrice = 0;

			product.selected_price = appliedPrice;

			// Mostrar visualmente los descuentos aplicados
			const autoDiscountStr = applied_rules.map(r => `${r.percentage}%`).join(' / ');
			if (product.manual_discount > 0 && applied_rules.length > 0) {
				product.discount = `${product.manual_discount}% / ${autoDiscountStr}`;
			} else if (product.manual_discount > 0) {
				if (parseFloat(String(product.discount).replace(/,/g, '.')) !== product.manual_discount) {
					product.discount = product.manual_discount;
				}
			} else if (applied_rules.length > 1) {
				product.discount = autoDiscountStr;
			} else if (applied_rules.length === 1) {
				product.discount = applied_rules[0].percentage;
			} else {
				if (parseFloat(String(product.discount).replace(/,/g, '.')) !== 0) {
					product.discount = '';
				}
			}

			product.applied_discounts = applied_rules;

			const lineOriginalSubtotal = qty * appliedPrice;
			const lineFinalSubtotal = qty * finalUnitPrice;

			product.subtotal = parse(lineFinalSubtotal, decimals);
			original_subtotal_usd += parse(lineOriginalSubtotal, decimals);
			subtotal_usd += product.subtotal;
		}

		// ---------------------------------------------------------
		// 3. APLICAR DESCUENTOS GLOBALES AL TOTAL (CORREGIDO A CASCADA)
		// ---------------------------------------------------------
		let currentSubtotal = subtotal_usd;

		// A. Aplicar primero el form.discount (si el usuario escribió un descuento manual)
		if (form.discount > 0) {
			let desc = parseFloat(form.discount);
			if (desc > 100) desc = 100;
			currentSubtotal -= (currentSubtotal * (desc / 100));
		}

		// B. Aplicar cascada de reglas automáticas globales
		new_general_discounts.forEach(gd => {
			let desc = parseFloat(gd.value);
			if (desc > 100) desc = 100;
			// La magia de la cascada: se descuenta del "currentSubtotal" que cada vez es menor
			currentSubtotal -= (currentSubtotal * (desc / 100));
		});

		if (currentSubtotal < 0) currentSubtotal = 0;

		// Calcular el dinero total descontado (solo descuentos globales, para igualar PDF)
		totalDiscountAmount = subtotal_usd - currentSubtotal;
		// No sobreescribimos subtotal_usd con currentSubtotal para que la UI lo muestre puro (ej: 156.133)

		// ---------------------------------------------------------
		// 4. TOTALES FINALES
		// ---------------------------------------------------------
		const subtotal_bs = parse(subtotal_usd * exchangeRate, decimals);
		const total_usd = parse(currentSubtotal, decimals);
		const total_bs = parse(total_usd * exchangeRate, decimals);
		let left_usd = parse(total_usd - paid_usd, decimals);
		let left_bs = parse(left_usd * exchangeRate, decimals);
		let change_usd = 0;
		let change_bs = 0;

		if (left_usd < 0) {
			change_usd = parse(left_usd * -1, decimals);
			change_bs = parse(change_usd * exchangeRate, decimals);
			left_usd = parse(0, decimals);
			left_bs = parse(0, decimals);
		}

		const totalDiscountPercentage = totalDiscountAmount > 0 ? (totalDiscountAmount / original_subtotal_usd) * 100 : 0;

		// Construir appliedDiscountsRules agrupando los descuentos por producto (igual que la app)
		const appliedDiscountsRulesMap = {};
		products.forEach(item => {
			const productData = item.product || item;
			if (!item.applied_discounts || item.applied_discounts.length === 0) return;
			const qty = productData?.decimal_stock == Constants.DECIMAL_STOCK.YES ? parseFloat(item.quantity) : parseInt(item.quantity);
			const basePrice = parseFloat(item.selected_price || item.original_price || item.sale_price || item.price || productData.sale_price || productData.price);
			let runningSubtotal = qty * basePrice;
			if (item.manual_discount > 0) {
				const manualDesc = parseFloat(item.manual_discount) > 100 ? 100 : parseFloat(item.manual_discount);
				runningSubtotal -= runningSubtotal * (manualDesc / 100);
			}

			item.applied_discounts.forEach(ad => {
				const mapKey = `${ad.discount_id}_${ad.percentage}`;
				if (!appliedDiscountsRulesMap[mapKey]) {
					appliedDiscountsRulesMap[mapKey] = {
						id: ad.discount_id,
						name: ad.name,
						percentage: parseFloat(ad.percentage),
						totalAmount: 0,
					};
				}
				const pct = parseFloat(ad.percentage) > 100 ? 100 : parseFloat(ad.percentage);
				const ruleAmount = runningSubtotal * (pct / 100);
				runningSubtotal -= ruleAmount;
				appliedDiscountsRulesMap[mapKey].totalAmount = parse(
					appliedDiscountsRulesMap[mapKey].totalAmount + parse(ruleAmount, decimals), decimals
				);
			});
		});

		// Construir appliedDiscountsGeneral (descuentos globales) igual que la app
		const appliedDiscountsGeneral = [];
		// Agregar form.discount como item con discount_id: null (igual que la app)
		const allGlobalDiscounts = [];
		if (form.discount > 0) {
			allGlobalDiscounts.push({ discount_id: null, value: parseFloat(form.discount) });
		}
		new_general_discounts.forEach(gd => {
			allGlobalDiscounts.push(gd);
		});

		allGlobalDiscounts.forEach(gd => {
			const masterInfo = discountsRules?.find(r => r.id === gd.discount_id);
			appliedDiscountsGeneral.push({
				id: gd.discount_id,
				name: gd.discount_id == null ? 'Descuento' : masterInfo?.name || 'Descuento General',
				percentage: parseFloat(gd.value),
				totalAmount: 0,
			});
		});

		// Calcular totalAmount en cascada sobre subtotal_usd (igual que la app)
		if (appliedDiscountsGeneral.length > 0) {
			let cascadeSubtotal = subtotal_usd;
			appliedDiscountsGeneral.forEach(gd => {
				let desc = parseFloat(gd.percentage);
				if (desc > 100) desc = 100;
				const discountAmount = cascadeSubtotal * (desc / 100);
				gd.totalAmount = parse(discountAmount, decimals);
				cascadeSubtotal -= discountAmount;
			});
		}

		const appliedDiscountsRules = Object.values(appliedDiscountsRulesMap).concat(appliedDiscountsGeneral);

		await this.setState({
			order: {
				...order,
				details: products
			},
			form: {
				...form,
				change: change_usd,

				general_discounts: new_general_discounts
			},
			appliedDiscountsRules,
			totals: {
				subtotal_usd, subtotal_bs, paid_usd, paid_bs, left_usd, left_bs, total_bs, total_usd, change_bs, change_usd,
				total_discount: parse(totalDiscountAmount, decimals),
				total_discount_percentage: parse(totalDiscountPercentage, decimals),
				original_subtotal_usd: parse(original_subtotal_usd, decimals),
			}
		});
	}

	getTotal = () => {
		let total = this.state.totals.total_usd;
		if (this.state.form.show_taxes == Constants.ORDERS.SHOW_TAXES.YES) {
			const iva = this.getIva();
			total += Number(iva);
		}
		return parse(total, this.getDecimals());
	}

	getDiscount = () => {
		return parse(this.state.totals.total_discount, this.getDecimals());
	}

	getProductDiscounts = () => {
		return 0; // Calculado en setTotals
	}

	getSubtotal = () => {
		return parse(this.state.totals.subtotal_usd, this.getDecimals());
	}

	getIva = () => {
		const IVA = this.state.IVA;
		let iva = 0;
		const decimals = this.getDecimals();

		const totals = this.state.totals || {};
		const subtotal_usd = totals.subtotal_usd || 0;
		const total_usd = totals.total_usd || 0;

		// Proporción del subtotal que queda después de aplicar descuentos globales (ej: 0.9 si hubo 10% descuento)
		const globalDiscountRatio = subtotal_usd > 0 ? (total_usd / subtotal_usd) : 1;

		this.state.order?.details?.map((i) => {
			let product_iva = 0;
			if (!!this.state.form.show_taxes && (i.product.exento == Constants.PRODUCT_EXENTO.NO)) {
				const discountedSubtotal = (i.subtotal || 0) * globalDiscountRatio;
				product_iva = parse((discountedSubtotal * IVA) / 100, decimals);
			}
			iva += product_iva;
		});

		return parse(iva, decimals);
	}

	getProductIva = (product) => {
		const IVA = this.state.IVA;
		let iva = 0;
		const decimals = this.getDecimals();

		const totals = this.state.totals || {};
		const subtotal_usd = totals.subtotal_usd || 0;
		const total_usd = totals.total_usd || 0;
		const globalDiscountRatio = subtotal_usd > 0 ? (total_usd / subtotal_usd) : 1;

		const filteredDetails = this.state.order?.details?.filter(detail => detail.product.id === product.id);
		filteredDetails?.forEach(i => {
			let product_iva = 0;
			if (!!this.state.form.show_taxes && (i.product.exento == Constants.PRODUCT_EXENTO.NO)) {
				const discountedSubtotal = (i.subtotal || 0) * globalDiscountRatio;
				product_iva = parse((discountedSubtotal * IVA) / 100, decimals);
			}
			iva += product_iva;
		});

		return iva;
	}

	getIvaBs = () => {
		const conversion = this.state.order?.conversion;
		let iva_bs = (this.getIva() || 0) * conversion;
		return parse(iva_bs, this.getDecimals());
	}

	applyProductDiscount = (subtotal, discountStr, decimals) => {
		if (discountStr == null || discountStr === '' || subtotal <= 0) return subtotal;

		// Normalizar: quitar espacios y signos %, reemplazar coma por punto
		const raw = String(discountStr).replace(/%/g, '').trim().replace(/,/g, '.');

		let result = subtotal;

		if (raw.includes('/')) {
			// Descuento en cascada: "5 / 3" => aplica 5% y luego 3% sobre el resultado
			raw.split('/').forEach(part => {
				const pct = parseFloat(part.trim());
				if (!isNaN(pct) && pct > 0) {
					const d = pct > 100 ? 100 : pct;
					result -= result * (d / 100);
				}
			});
		} else if (raw.includes('+')) {
			// Descuento aditivo: "5 + 3" => aplica 5% y luego 3% sobre el resultado
			raw.split('+').forEach(part => {
				const pct = parseFloat(part.trim());
				if (!isNaN(pct) && pct > 0) {
					const d = pct > 100 ? 100 : pct;
					result -= result * (d / 100);
				}
			});
		} else {
			// Descuento simple: "5" => aplica 5%
			const pct = parseFloat(raw);
			if (!isNaN(pct) && pct > 0) {
				const d = pct > 100 ? 100 : pct;
				result -= result * (d / 100);
			}
		}

		return result < 0 ? 0 : result;
	}

	addProduct = () => {
		document.getElementsByClassName('modal').item(0).style.zIndex = 1040;
		this.setState({ visible_product: true });
	}

	onCloseProduct = (_products = null) => {
		document.getElementsByClassName('modal').item(0).style.zIndex = 1050;
		this.setState({
			visible_product: false
		});
		if (_products) {
			let order = { ...this.state.order };
			let products = Globals.copy(this.state.order.details);

			_products.forEach(item => {
				let productIndex;
				productIndex = item.type === Constants.PRODUCTS_TYPE.SIZE_COLOR
					? products.findIndex(p => p.product_id === item.id && p.size_id === item.size_id && p.color_id === item.color_id)
					: products.findIndex(p => p.product_id === item.id);

				if (productIndex >= 0) {
					const newQuantity = parseFloat(products[productIndex].quantity) + (item.quantity ?? 1);
					if (newQuantity > products[productIndex].stock)
						return Globals.showError(`No hay suficiente stock de ${item.name} (${products[productIndex].stock} disponibles)`)

					products[productIndex].quantity = parseFloat(newQuantity).toFixed(2);
					products[productIndex]._edited = true;

				} else {
					products.push({
						...item,
						product: item,
						_edited: true,
						quantity: item.quantity ?? 1,
						product_id: item.id,
						selected_price: item.sale_price,
						price: item.sale_price,
						warehouse_id: item.warehouse_id,
					});
				}
			});
			this.setState({
				order: { ...order, details: products }
			}, () => this.setTotals());
		}
	}

	setPaymentType = (status) => {
		this.setState({
			form: {
				...this.state.form,
				status
			}
		}, () => this.setTotals());
	}
	_unusedSetPaymentType = (status) => {
		this.setState({
			form: {
				...this.state.form,
				status
			}
		});
	}

	openDates = () => {
		this.setState({
			visible_dates: true
		});
	}

	onCloseDates = (dates = null) => {
		this.setState({
			visible_dates: false,
			dates: dates || this.state.dates
		});
	}

	changeValue = (value, target, index, callback = () => { }, isAutoPrice = false) => {
		this.setState(state => {
			const details = [...state.order.details];
			details[index][target] = value;
			details[index]._edited = true;
			// Si el usuario cambia el campo de descuento, resetear manual_discount
			// para que setTotals lo re-parsee desde el nuevo valor ingresado
			if (target === 'discount') {
				const rawDisc = String(value || '0').replace(/%/g, '').trim().replace(/,/g, '.');
				if (rawDisc.includes('/')) {
					details[index].manual_discount = parseFloat(rawDisc.split('/')[0]) || 0;
				} else if (rawDisc.includes('+')) {
					details[index].manual_discount = parseFloat(rawDisc.split('+')[0]) || 0;
				} else {
					details[index].manual_discount = parseFloat(rawDisc) || 0;
				}
			}
			if (target === 'selected_price') {
				details[index]._user_selected_price = value;
				details[index]._user_changed_price = !isAutoPrice;
				if (isAutoPrice) details[index].original_price = value;
			}
			return {
				order: {
					...state.order,
					details
				}
			}
		}, () => { callback(); this.setTotals(); });
	}

	onCloseSeller = (seller = null) => {
		this.setState({ visible_modal: false, seller: seller || this.state.seller, orderModified: true }, () => this.setTotals());
	}

	selectSeller = () => {
		this.setState({
			visible_modal: true
		});
	}

	addPaymentMethod = (methodId) => {
		const method = (this.props.methods || []).find(m => m.value == methodId);
		if (!method) return;
		const methods_selected = [...this.state.methods_selected];
		methods_selected.push({
			id: method.value,
			name: method.label,
			amount: ''
		});
		this.setState({ methods_selected });
	}

	removePaymentMethod = (index) => {
		const methods_selected = [...this.state.methods_selected];
		methods_selected.splice(index, 1);
		this.setState({ methods_selected });
	}

	changeMethodAmount = (amount, index) => {
		if (Globals.validateDouble(amount) || amount === '') {
			const methods_selected = [...this.state.methods_selected];
			methods_selected[index].amount = amount;
			this.setState({ methods_selected });
		}
	}

	render() {
		const { order, visible_product } = this.state;
		const can_include_taxes = Globals.canIncludeTaxes(this.props.user);
		const decimals = this.getDecimals();

		return (
			<section className="dup-order-modal">
				{/* TOPBAR */}
				<header className="dup-topbar">
					<div className="dup-title-wrap">
						<div className="dup-iconbox">
							<i className="fa fa-pencil-square-o"></i>
						</div>
						<div>
							<h1>Editar pedido #{order?.correlative_number || order?.id || ''}</h1>
							<p className="dup-subtitle">Modifica los productos, precios, descuentos y detalles del pedido.</p>
						</div>
					</div>
					<button className="dup-close" aria-label="Cerrar" onClick={() => this.props.onClose(false)}>×</button>
				</header>

				{/* CONTENT */}
				<div className="dup-content">
					{/* LEFT COLUMN */}
					<main className="dup-left">
						{/* Resumen Subtotal y Total */}
						<div className="dup-summary">
							<div className="dup-sumrow">
								<span>SUBTOTAL:</span>
								<span>$ {Globals.formatMiles(Number(this.state.totals.original_subtotal_usd || this.getSubtotal() || 0).toFixed(decimals))}</span>
							</div>
							{(this.state.appliedDiscountsRules || []).filter(i => i.name !== 'Precio Especial').map((item, idx) => (
								<div className="dup-sumrow" key={`disc-rule-${idx}`}>
									<span>{item.name}:</span>
									<span style={{ color: '#e74c3c' }}>-$ {Globals.formatMiles(Number(item.totalAmount || 0).toFixed(decimals))}</span>
								</div>
							))}
							{this.state.form.show_taxes === Constants.ORDERS.SHOW_TAXES.YES && (
								<div className="dup-sumrow">
									<span>{this.state.countryEquivalent?.ivaAbbreviation || 'IVA'}:</span>
									<span>$ {Globals.formatMiles(Number(this.getIva() || 0).toFixed(decimals))}</span>
								</div>
							)}
							<div className="dup-sumrow">
								<span>TOTAL:</span>
								<span>$ {Globals.formatMiles(Number(this.getTotal() || 0).toFixed(decimals))}</span>
							</div>
						</div>

						{/* Estado de pago e Impuesto */}
						<div className="dup-payment-status">
							{can_include_taxes ? (
								<label className="dup-checkline">
									<input
										type="checkbox"
										checked={this.state.form.show_taxes === Constants.ORDERS.SHOW_TAXES.YES}
										onChange={() => this.checkedChange(!this.state.form.show_taxes)}
									/>
									Incluir Impuesto <span>ⓘ</span>
								</label>
							) : <div />}

							<button
								type="button"
								className={`dup-statusbtn ${this.state.form.status === Constants.PAYMENT_TYPES.PAID ? 'active' : ''}`}
								onClick={() => this.setPaymentType(Constants.PAYMENT_TYPES.PAID)}
							>
								💵 &nbsp; PAGADO
							</button>

							<button
								type="button"
								className={`dup-statusbtn ${this.state.form.status === Constants.PAYMENT_TYPES.TO_PAY ? 'active' : ''}`}
								onClick={() => this.setPaymentType(Constants.PAYMENT_TYPES.TO_PAY)}
							>
								▱ &nbsp; POR COBRAR
							</button>
						</div>

						{/* Sección Productos del pedido */}
						<div className="dup-section-head">
							<div className="dup-section-title">
								<span className="dup-mini"><i className="fa fa-th-large"></i></span>
								Productos del pedido
							</div>
							<button type="button" className="dup-primary" onClick={this.addProduct}>
								+ Agregar producto
							</button>
						</div>

						{/* Lista de productos scrollable */}
						<div className="dup-products-scroll">
							{(!order || !order.details || order.details.length === 0) ? (
								<div className="dup-no-items">No hay productos en el pedido</div>
							) : (
								order.details.map((item, index) => {
									const product = item.product || item;
									let stock = product?.stock || 0;
									let label_total = '(' + item.quantity + ' × ' + Globals.formatMiles(item.selected_price || item.price, true) + ')';
									if (item.special_price_applied && item.special_price_limit > 0 && parseFloat(item.quantity) > parseFloat(item.special_price_limit)) {
										const specialQty = parseFloat(item.special_price_limit);
										const regularQty = parseFloat(item.quantity) - specialQty;
										label_total = '(' + specialQty + ' × ' + Globals.formatMiles(item.original_special_price, true) + ' + ' + regularQty + ' × ' + Globals.formatMiles(item.original_price, true) + ')';
									}
									let total = item.subtotal !== undefined
										? parseFloat(item.subtotal)
										: parse((item.selected_price || item.price || 0) * (item.quantity || 0), decimals);
									if (isNaN(total)) total = 0;

									if (item.discount != null && item.discount !== '') {
										let discountStr = String(item.discount);
										if (discountStr.includes('/') || discountStr.includes('+') || discountStr.includes('%')) {
											label_total += ' - ' + discountStr;
										} else {
											label_total += ' - ' + Globals.formatMiles(item.discount, true, '') + '%';
										}
									}

									if (!!this.state.form.show_taxes && !product.exento) {
										const prodIva = this.getProductIva(product);
										label_total += ' + ' + Globals.formatMiles(prodIva.toFixed(decimals), true) + ' ' + (this.state.countryEquivalent?.ivaAbbreviation || 'IVA');
										total += prodIva;
									}

									let size_color = null;
									let prices = product?.prices || [];

									if (product?.type == Constants.PRODUCTS_TYPE.SIZE_COLOR) {
										size_color = product?.size_colors?.find((i) => {
											if (item.size_id && item.color_id) {
												return i.size_id == item.size_id && i.color_id == item.color_id;
											}
											else if (item.size_id) {
												return i.size_id == item.size_id && i.color_id == null;
											}
											else if (item.color_id) {
												return i.color_id == item.color_id && i.size_id == null;
											}
										});
										prices = size_color?.prices || [];
										stock = size_color?.stock || 0;
									}

									const defaultPrice = size_color?.sale_price ?? product?.sale_price;
									const rawPrices = [];
									if (defaultPrice != null) rawPrices.push(parseFloat(defaultPrice));
									if (item.price != null) rawPrices.push(parseFloat(item.price));
									prices.forEach(p => rawPrices.push(parseFloat(p.price)));
									const uniquePrices = [...new Set(rawPrices.filter(p => !isNaN(p)))];
									const priceOptions = uniquePrices.map(p => ({
										value: p,
										label: Globals.formatMiles(p)
									}));

									return (
										<div className="dup-product-card" key={index}>
											<img
												className="dup-product-img"
												src={Globals.fromPhotos(product?.photo?.file)}
												alt={product?.name || 'Producto'}
												onError={e => { e.target.style.visibility = 'hidden'; }}
											/>
											<div>
												<div className="dup-pname">{product?.name}</div>
												<div className="dup-product-price-line">
													$ {Globals.formatMiles(Number(total || 0).toFixed(decimals))} {label_total}
												</div>

												{item.applied_discounts && item.applied_discounts.length > 0 && (
													<div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', margin: '4px 0' }}>
														{item.applied_discounts.map((rule, rIdx) => (
															<span
																key={rIdx}
																style={{
																	background: '#e8f5e9',
																	color: '#2e7d32',
																	fontSize: '11px',
																	padding: '2px 6px',
																	borderRadius: '4px',
																	fontWeight: '500'
																}}
															>
																🏷 {rule.name}: -{rule.percentage}%
															</span>
														))}
													</div>
												)}
												{item.special_price_applied && (
													<div style={{ margin: '2px 0' }}>
														<span
															style={{
																background: '#e3f2fd',
																color: '#1565c0',
																fontSize: '11px',
																padding: '2px 6px',
																borderRadius: '4px',
																fontWeight: '500'
															}}
														>
															🏷 Precio Especial {item.special_price_limit ? `(hasta ${item.special_price_limit} un.)` : ''}
														</span>
													</div>
												)}

												<div className="dup-product-fields">
													<div className="dup-field">
														<label>Precio</label>
														{priceOptions.length > 1 ? (
															<select
																value={parseFloat(item.special_price_applied && item.special_price_limit ? item.original_price : (item.selected_price || item.price))}
																onChange={e => this.changeValue(parseFloat(e.target.value), 'selected_price', index)}
															>
																{priceOptions.map((opt, i) => (
																	<option key={i} value={opt.value}>{opt.label}</option>
																))}
															</select>
														) : (
															<input
																type="number"
																step="0.01"
																value={(item.special_price_applied && item.special_price_limit ? item.original_price : (item.selected_price || item.price)) || ''}
																onChange={e => this.changeValue(parseFloat(e.target.value) || 0, 'selected_price', index)}
															/>
														)}
													</div>
													<div className="dup-field">
														<label>Descuento (%)</label>
														<input
															type="text"
															placeholder="Ej. 10 o 10 / 12"
															value={item.discount?.toString() || ''}
															onChange={e => this.changeValue(e.target.value, 'discount', index)}
														/>
														{item.discount != null && item.discount > 100 && (
															<div className="error-discount" style={{ color: '#e11d2e', fontSize: '11px', marginTop: '2px' }}>El descuento no puede ser mayor a 100%</div>
														)}
													</div>
												</div>

												{/* Selector de Talla / Color para productos configurados */}
												{product?.type == Constants.PRODUCTS_TYPE.SIZE_COLOR && (
													<div className="size-colors-form" style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '15px', alignItems: 'center' }}>
														{[...new Set(product?.size_colors?.filter((i) => i.color_id).map(i => i.color_id))].length > 0 && (
															<div className="colors" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
																<span style={{ fontSize: '12.5px', fontWeight: '650', color: '#213557' }}>Color:</span>
																<div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
																	{[...new Set(product?.size_colors?.filter((i) => i.color_id).map(i => i.color_id))].map((_item) => {
																		const isSelected = item.color_id == _item;
																		return (
																			<div
																				key={`color-${_item}`}
																				className={`circle ${isSelected ? 'selected' : ''}`}
																				style={{
																					width: 22,
																					height: 22,
																					borderRadius: '50%',
																					border: isSelected ? '2px solid #0f5fe8' : '1px solid #ccc',
																					boxShadow: isSelected ? '0 0 0 2px rgba(15, 95, 232, 0.3)' : 'none',
																					backgroundColor: product?.size_colors?.find(i => i.color_id == _item)?.color?.hex,
																					cursor: 'pointer',
																					transition: 'all 0.2s'
																				}}
																				onClick={() => {
																					this.changeValue(_item, 'color_id', index, () => {
																						const sc = product?.size_colors?.find((i) => {
																							if (item.size_id && item.color_id) return i.size_id == item.size_id && i.color_id == item.color_id;
																							if (item.size_id) return i.size_id == item.size_id && i.color_id == null;
																							if (item.color_id) return i.color_id == item.color_id && i.size_id == null;
																						});
																						if (sc) {
																							this.changeValue(sc?.sale_price, 'price', index, () => {
																								this.changeValue(sc?.sale_price, 'selected_price', index, () => {}, true);
																							});
																						}
																					});
																				}}
																			/>
																		);
																	})}
																</div>
															</div>
														)}
														{[...new Set(product?.size_colors?.filter((i) => i.size_id).map(i => i.size_id))].length > 0 && (
															<div className="sizes" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
																<span style={{ fontSize: '12.5px', fontWeight: '650', color: '#213557' }}>Talla:</span>
																<select
																	style={{
																		padding: '4px 8px',
																		borderRadius: '8px',
																		border: '1px solid #d7dfeb',
																		fontSize: '13px',
																		color: '#1a2947'
																	}}
																	value={item.size_id || ''}
																	onChange={e => {
																		const val = e.target.value ? Number(e.target.value) : null;
																		this.changeValue(val, 'size_id', index, () => {
																			const sc = product?.size_colors?.find((i) => {
																				if (item.size_id && item.color_id) return i.size_id == item.size_id && i.color_id == item.color_id;
																				if (item.size_id) return i.size_id == item.size_id && i.color_id == null;
																				if (item.color_id) return i.color_id == item.color_id && i.size_id == null;
																			});
																			if (sc) {
																				this.changeValue(sc?.sale_price, 'price', index, () => {
																					this.changeValue(sc?.sale_price, 'selected_price', index, () => {}, true);
																				});
																			}
																		});
																	}}
																>
																	<option value="">Seleccionar talla</option>
																	{[...new Set(product?.size_colors?.filter((i) => i.size_id).map(i => i.size_id))].map(_item => {
																		const size = product.size_colors.find(i => i.size_id == _item);
																		return (
																			<option key={size?.size?.id} value={size?.size?.id}>
																				{size?.size?.name}
																			</option>
																		);
																	})}
																</select>
															</div>
														)}
													</div>
												)}
											</div>

											{/* Botones de cantidad */}
											<div className="dup-qty-side">
												<button type="button" className="dup-qbtn" onClick={() => this.remove(index, product)}>−</button>
												<input
													className="dup-qty"
													type="number"
													value={
														product?.decimal_stock == Constants.DECIMAL_STOCK.NO
															? parseInt(item.quantity || 0)
															: item.quantity || 0
													}
													onChange={e => {
														if (product?.decimal_stock == Constants.DECIMAL_STOCK.NO) {
															if (Globals.validateInteger(e.target.value) || e.target.value == '') {
																if (this.state.config?.negative_stock == Constants.CONFIG.NO && e.target.value > stock) {
																	return;
																}
																this.changeManual(index, e.target.value);
															}
														} else {
															if (this.state.config?.negative_stock == Constants.CONFIG.NO && e.target.value > stock) {
																return;
															}
															this.changeManual(index, e.target.value);
														}
													}}
												/>
												<button type="button" className="dup-qbtn" onClick={() => this.add(index, item)}>＋</button>
												<button
													type="button"
													className="dup-trash"
													onClick={() => this.delete(index)}
													title="Eliminar"
												>
													🗑
												</button>
											</div>
										</div>
									);
								})
							)}
						</div>
					</main>

					{/* RIGHT COLUMN */}
					<aside className="dup-right">
						<button
							type="button"
							className="dup-finish"
							onClick={async () => {
								await this.setState({ disabled_button: true });
								this.submit();
							}}
							disabled={this.state.disabled_button}
						>
							GUARDAR CAMBIOS
						</button>

						<div className="dup-right-section">
							<h2>
								<i className="fa fa-pencil"></i>
								&nbsp; Información del pedido
							</h2>

							{/* Vendedor */}
							<div className="dup-field">
								<label>Vendedor (Opcional)</label>
								<select
									value={this.state.seller?.id || this.state.seller?.value || this.state.order?.seller_id || ''}
									onChange={async e => {
										const val = e.target.value;
										if (!val) {
											await this.setState({ seller: null, orderModified: true });
											this.setTotals();
											return;
										}
										const s = (this.state.fullSellers || []).find(x => +x.id === +val) ||
											(this.props.sellers || []).find(x => +x.value === +val);
										await this.setState({ seller: s || null, orderModified: true });
										this.setTotals();
									}}
								>
									<option value="">Seleccione un vendedor</option>
									{(() => {
										const baseOptions = this.props.sellers || [];
										const currentSeller = this.state.seller || this.state.order?.seller;
										if (currentSeller && !baseOptions.some(s => +s.value === +currentSeller.id)) {
											return [
												<option key={currentSeller.id} value={currentSeller.id}>{currentSeller.name}</option>,
												...baseOptions.map(s => <option key={s.value} value={s.value}>{s.label}</option>)
											];
										}
										return baseOptions.map(s => <option key={s.value} value={s.value}>{s.label}</option>);
									})()}
								</select>
							</div>

							{/* Cliente */}
							<div className="dup-field">
								<label>Cliente *</label>
								<select
									value={this.state.form.client_id || ''}
									onChange={e => {
										const clientId = e.target.value;
										const foundClient = (this.props.clients || []).find(c => +c.value === +clientId) || null;
										this.setState({
											client: foundClient,
											form: { ...this.state.form, client_id: clientId }
										}, () => this.setTotals());
									}}
								>
									<option value="">Seleccione un cliente</option>
									{(this.props.clients || []).map(c => (
										<option key={c.value} value={c.value}>{c.label}</option>
									))}
								</select>
							</div>

							{/* Pago Inicial y Días de Crédito (si status es TO_PAY) */}
							{this.state.form.status == Constants.PAYMENT_TYPES.TO_PAY && (
								<div className="dup-two-cols">
									<div className="dup-field">
										<label>Pago Inicial (Opcional)</label>
										<input
											type="number"
											step="0.01"
											placeholder="0.00"
											value={this.state.form.initial_payment?.toString() || ''}
											onChange={e => {
												if (Globals.validateDouble(e.target.value) || e.target.value === '') {
													this.change(e.target.value, 'initial_payment');
												}
											}}
										/>
									</div>
									<div className="dup-field">
										<label>Días de crédito *</label>
										<input
											type="number"
											placeholder="Ej. 15"
											value={this.state.form.credit_days}
											onChange={e => {
												if (Globals.validateInteger(e.target.value) || e.target.value === '') {
													this.change(e.target.value, 'credit_days');
												}
											}}
										/>
									</div>
								</div>
							)}

							{/* Método de pago */}
							<div className="dup-field">
								<label>Agregar Método de Pago</label>
								<select
									value=""
									onChange={e => {
										const val = e.target.value;
										if (val) this.addPaymentMethod(val);
									}}
								>
									<option value="">Seleccione uno o varios</option>
									{(this.props.methods || [])
										.filter(m => !this.state.methods_selected.some(ms => ms.id == m.value))
										.map(m => (
											<option key={m.value} value={m.value}>{m.label}</option>
										))}
								</select>
							</div>

							{/* Montos por método de pago */}
							{this.state.methods_selected.map((item, index) => {
								const methodName = item.name || (this.props.methods || []).find(m => m.value == item.id)?.label || 'Método';
								return (
									<div className="dup-amount-line" key={`method-sel-${index}`}>
										<strong title={methodName}>{methodName}</strong>
										<input
											type="number"
											step="0.01"
											min="0"
											placeholder="Monto"
											value={item.amount != null ? item.amount : ''}
											onChange={e => this.changeMethodAmount(e.target.value, index)}
										/>
										<button
											type="button"
											className="dup-trash"
											title="Quitar"
											onClick={() => this.removePaymentMethod(index)}
										>
											🗑
										</button>
									</div>
								);
							})}

							{/* Descuentos */}
							<div className="dup-two-cols">
								<div className="dup-field">
									<label>Descuento (%)</label>
									<input
										type="text"
										placeholder="Opcional"
										value={this.state.form.discount?.toString() || ''}
										onChange={async e => {
											let value = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
											if ((value.match(/\./g) || []).length > 1) {
												value = value.substring(0, value.length - 1);
											}
											if (Globals.validateDouble(value) || value === '') {
												await this.setState({ form: { ...this.state.form, discount: value } });
												this.setTotals();
											}
										}}
									/>
									{(this.state.form.discount != null && this.state.form.discount !== '' && parseFloat(this.state.form.discount) > 100) && (
										<div className="error-discount" style={{ color: '#e11d2e', fontSize: '11px', marginTop: '2px' }}>El descuento no puede ser mayor a 100%</div>
									)}
								</div>

								{(this.state.discountsRules || [])
									.filter(master => master.type === 'general' && master.status === 1)
									.map(discount => {
										const currentDiscount = this.state.form.general_discounts.find(d => d.discount_id === discount.id);
										const currentValue = currentDiscount ? currentDiscount.value : '';
										return (
											<div className="dup-field" key={`general-discount-input-${discount.id}`}>
												<label>{discount.name} (%)</label>
												<input
													type="text"
													placeholder="Opcional"
													value={currentValue}
													onChange={async e => {
														let value = e.target.value.replace(/,/g, '.').replace(/[^0-9.]/g, '');
														if ((value.match(/\./g) || []).length > 1) {
															value = value.substring(0, value.length - 1);
														}
														if (Globals.validateDouble(value) || value === '') {
															await this.changeGeneralDiscount(discount.id, value);
														}
													}}
												/>
												{(currentValue != null && currentValue > 100) && (
													<div className="error-discount" style={{ color: '#e11d2e', fontSize: '11px', marginTop: '2px' }}>El descuento no puede ser mayor a 100%</div>
												)}
											</div>
										);
									})}
							</div>

							{/* Badges informativos de descuentos automáticos aplicados */}
							{(() => {
								const appliedAutomaticDiscounts = [];
								if (this.state.form.general_discounts && this.state.discountsRules) {
									this.state.form.general_discounts.forEach(gd => {
										const ruleInfo = this.state.discountsRules.find(r => r.id === gd.discount_id);
										if (ruleInfo && ruleInfo.type !== 'general') {
											appliedAutomaticDiscounts.push({
												name: ruleInfo.name,
												percentage: gd.value,
												icon: 'fa-clock-o'
											});
										}
									});
								}
								if (order?.details) {
									order.details.forEach(item => {
										if (item.applied_discounts && item.applied_discounts.length > 0) {
											item.applied_discounts.forEach(ad => {
												const existing = appliedAutomaticDiscounts.find(d => d.name === ad.name && d.percentage === ad.percentage);
												if (!existing) {
													appliedAutomaticDiscounts.push({
														name: ad.name,
														percentage: ad.percentage,
														icon: 'fa-cube'
													});
												}
											});
										}
										if (item.special_price_applied) {
											const existing = appliedAutomaticDiscounts.find(d => d.name === 'Precio Especial');
											if (!existing) {
												appliedAutomaticDiscounts.push({ name: 'Precio Especial', percentage: 'Especial', icon: 'fa-tag' });
											}
										}
									});
								}
								return appliedAutomaticDiscounts.length > 0 ? (
									<div style={{ border: '2px solid #2874A6', borderRadius: '8px', padding: '10px', backgroundColor: '#eef2f7', width: '100%', margin: '8px 0' }}>
										<label style={{ color: '#00204a', display: 'block', fontSize: '13px', fontWeight: 'bold', marginBottom: '6px' }}>
											Descuentos aplicados automáticamente
										</label>
										<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
											{appliedAutomaticDiscounts.map((ad, idx) => (
												<div key={`auto-discount-${idx}`} style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#e2e9f3', color: '#333', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: '600', gap: '6px' }}>
													<i className={`fa ${ad.icon}`} style={{ color: '#6c757d' }}></i>
													<span>{ad.name}</span>
													{ad.percentage !== 'Especial' ? (
														<span style={{ backgroundColor: '#2874A6', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
															{ad.percentage}%
														</span>
													) : (
														<span style={{ backgroundColor: '#198754', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontWeight: 'bold' }}>
															{ad.percentage}
														</span>
													)}
												</div>
											))}
										</div>
									</div>
								) : null;
							})()}

							{/* Comprobante de pago */}
							<div className="dup-field">
								<label>Comprobante de pago</label>
								<div
									className="dup-upload"
									onClick={() => document.getElementById('edit-upload-voucher').click()}
								>
									☁️ &nbsp; <strong>{this.state.form.file?.name || this.state.form.currentFileName || 'Subir comprobante (Opcional)'}</strong><br />
									<span className="dup-muted">JPG, PNG o PDF. Máx. 5MB</span>
								</div>
								<input
									id="edit-upload-voucher"
									type="file"
									accept="image/*,.pdf"
									style={{ display: 'none' }}
									onChange={e => this.change(e.target.files[0], 'file')}
								/>
							</div>

							{/* Información adicional */}
							<div className="dup-field">
								<label>Información adicional</label>
								<textarea
									placeholder="Agregar información adicional (Opcional)"
									value={this.state.form.information}
									onChange={e => this.change(e.target.value, 'information')}
								></textarea>
							</div>
						</div>
					</aside>
				</div>

				{/* Modal de Agregar Producto */}
				<Modal
					title="Seleccionar producto"
					onClose={() => this.onCloseProduct()}
					visible={visible_product}
				>
					<SelectProduct
						onSelect={this.onCloseProduct}
						onClose={() => this.onCloseProduct()}
						warehouses={this.state.warehouses}
						formatWarehouses={this.state.formatWarehouses}
					/>
				</Modal>
			</section>
		);
	}
}

const SizeColorForm = ({ product, onChange }) => {

	const [colors, setColors] = useState([]);
	const [sizes, setSizes] = useState([]);

	function getUniqueItems() {
		const _colors = product.size_colors.filter(i => i.color_id).reduce((prev, curr) => prev.set(curr.color_id, curr.color), new Map());
		const _sizes = product.size_colors.filter(i => i.size_id).reduce((prev, curr) => prev.set(curr.size_id, curr.size), new Map());

		setColors([..._colors.values()]);
		setSizes([..._sizes.values()]);
	}

	useEffect(() => {
		getUniqueItems();
	}, []);

	// Helper: obtener el stock de una talla (considerando color si aplica)
	function getSizeStock(size) {
		if (!product || !product.size_colors) return null;
		const matches = product.size_colors.filter(sc => sc.size_id === size.id);
		if (matches.length === 0) return null;
		if (product.color_id) {
			const specific = matches.find(sc => sc.color_id === product.color_id);
			return specific ? (specific.stock ?? 0) : null;
		}
		return matches.reduce((acc, sc) => acc + (sc.stock ?? 0), 0);
	}

	function getColorStock(color) {
		if (!product || !product.size_colors) return null;
		const matches = product.size_colors.filter(sc => sc.color_id === color.id);
		if (matches.length === 0) return null;
		if (product.size_id) {
			const specific = matches.find(sc => sc.size_id === product.size_id);
			return specific ? (specific.stock ?? 0) : null;
		}
		return matches.reduce((acc, sc) => acc + (sc.stock ?? 0), 0);
	}

	return (
		<div className="size-colors-form">
			{!!sizes.length && (
				<div className="sizes">
					<Select
						label="Talla"
						labelClass="material"
						className="material"
						disabledFirst
						options={sizes.map(item => {
							const stock = getSizeStock(item);
							const noStock = stock !== null && stock <= 0;
							return {
								value: item.id,
								label: noStock ? `${item.name} (sin stock)` : item.name,
								disabled: noStock,
							};
						})}
						value={product.size_id}
						onChange={e => onChange(Number(e.target.value), 'size_id')}
					/>
				</div>
			)}

			{!!colors.length && (
				<div className="colors">
					<SelectActions
						label="Color"
						options={colors.map(item => {
							const stock = getColorStock(item);
							const noStock = stock !== null && stock <= 0;
							return {
								value: item.id,
								label: noStock
									? (<span style={{ opacity: 0.4 }}><div className="circle" style={{ backgroundColor: item.hex, display: 'inline-block' }} /> (sin stock)</span>)
									: (<div className="circle" style={{ backgroundColor: item.hex }} />),
								actions: [],
								isDisabled: noStock,
							};
						})}
						value={product.color_id}
						onChange={id => onChange(Number(id), 'color_id')}
					/>
				</div>
			)}
		</div>
	);
}

const SelectProduct = ({ onSelect, onClose, warehouses, formatWarehouses }) => {
	const user = useSelector(state => state.user);
	const mainWarehouse = user.warehouse_id || user.warehouse_principal;
	const [products, setProducts] = useState([]);
	const [selected, setSelected] = useState([]);
	const [form, setForm] = useState({ warehouse_id: mainWarehouse, search: '' });

	//filtro los productos, solo los que tengan stock > 0
	const products_filter = products.map(product => {
		let totalStock = product.stock;

		if (product.size_colors) {
			// Filtramos los colores que tienen stock > 0
			product.size_colors = product.size_colors.filter(color => color.stock > 0);
			totalStock += product.size_colors.reduce((total, color) => total + color.stock, 0);
		}

		let matchSearch = true;
		if (form.search) {
			const search = form.search.toLowerCase();
			matchSearch = product?.name?.toLowerCase()?.includes(search) || product?.code?.toLowerCase()?.includes(search);
		}

		if (totalStock > 0 && matchSearch) {
			return product;
		} else {
			return null;
		}
	}).filter(Boolean); // Filtramos los productos null

	const select = (item) => {
		if (selected.includes(item.id)) {
			const others = selected.filter(x => x !== item.id);
			setSelected(others);
		} else {
			setSelected([...selected, item.id]);
		}
	}

	const onSelectWarehouse = async (warehouse_id) => {
		setForm({ ...form, warehouse_id: warehouse_id });

		Globals.setLoading();
		try {
			const res = await axios.post('web/admin/warehouses', {
				web: true,
				user_id: user.id,
				is_select: true,
				warehouse_id: warehouse_id,
				with_products: true,
				unique_by_size_color: true,
			});

			if (res.data && res.data.warehouses && res.data.warehouses.length > 0) {
				const selectedWarehouse = res.data.warehouses[0];

				if (selectedWarehouse && selectedWarehouse.products) {
					const productsList = selectedWarehouse.products.map(i => {
						const total_quantity = i.total_quantity;
						if (total_quantity <= 0) return null;
						return {
							...i.product,
							total_quantity: total_quantity
						};
					}).filter(product => product !== null);
					setProducts(productsList);
				} else {
					setProducts([]);
				}
			} else {
				setProducts([]);
			}
		} catch (error) {
			console.error('Error fetching warehouse products: ', error);
			Globals.showError('Error al cargar los productos del almacén');
		} finally {
			Globals.quitLoading();
		}
	}

	const submit = () => {
		onSelect(products.filter(x => selected.includes(x.id)).map(x => ({ ...x, warehouse_id: form.warehouse_id })));
		onClose();
	}

	useEffect(() => {
		onSelectWarehouse(mainWarehouse);
	}, []);

	const canSelectWarehouse = user.level_id == Constants.ROLE_ADMIN || (user.level_id == Constants.ROLE_MODERATOR && user.warehouse_id === null);

	return (
		<div id="container-create-edit-quote-select-product">
			{canSelectWarehouse && (
				<Select
					label="Almacén"
					className="material"
					labelClass="material"
					value={form.warehouse_id}
					options={formatWarehouses}
					onChange={e => onSelectWarehouse(parseInt(e.target.value))}
				/>
			)}

			<Input
				color=" "
				placeholder="Buscar por nombre"
				className="material"
				labelClass="material"
				onChange={e => setForm({ ...form, search: e.target.value })}
			/>

			{!!selected.length && (
				<div className="product-totals">
					<span>Seleccionados: {selected.length}</span>
					<button
						type="button"
						className="done"
						title="Agregar a la cotización"
						onClick={() => submit()}
					>
						<Icon name="check" />
					</button>
				</div>
			)}

			{products_filter.map((item, index) => {
				const isSelected = selected.includes(item.id);
				return (
					<div
						key={`product-item-${index}`}
						className={`product-item ${isSelected ? 'selected' : ''}`}
						onClick={() => select(item)}
					>
						<div className="product-image">
							<img src={Globals.fromPhotos(item?.photo?.file)} alt="Producto" />
						</div>
						<div className="product-details">
							<span className="product-name" title={item?.name}>{item?.name}</span>
						</div>
						<div>${item?.sale_price}</div>
					</div>
				)
			})}
		</div>
	);
}

export default connect(state => {
	return {
		user: state.user,
		currency: state.currency,
	}
})(EditOrder);